"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _redux = require("redux");
var _reactRouterDom = require("react-router-dom");
var _Tab = _interopRequireDefault(require("../../common/Tab/Tab"));
var _OpenOrders = _interopRequireDefault(require("../OpenOrders"));
var _FilledOrders = _interopRequireDefault(require("../FilledOrders"));
var _InactiveOrders = _interopRequireDefault(require("../InactiveOrders"));
var _MarginOpenPositions = _interopRequireDefault(require("../MarginOpenPositions"));
var _PositionHistory = _interopRequireDefault(require("../PositionHistory"));
var _HeaderWithFilter = _interopRequireDefault(require("../HeaderWithFilter"));
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _orderHistorySelectors = require("../../../redux/selectors/orderHistorySelectors");
var _selectors = require("../../../redux/margin/selectors");
require("../OrderHistoryComponent.css");
require("../OrderHistoryTables.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var MarginOrderHistoryComponent = /*#__PURE__*/function (_Component) {
  function MarginOrderHistoryComponent() {
    _classCallCheck(this, MarginOrderHistoryComponent);
    return _callSuper(this, MarginOrderHistoryComponent, arguments);
  }
  _inherits(MarginOrderHistoryComponent, _Component);
  return _createClass(MarginOrderHistoryComponent, [{
    key: "_getPanes",
    value: function _getPanes() {
      var _this$props = this.props,
        config = _this$props.config,
        t = _this$props.t,
        openOrdersCount = _this$props.openOrdersCount,
        openPositionsCount = _this$props.openPositionsCount;
      var panes = [{
        menuItem: t('Open Orders ({{openOrdersCount}})', {
          openOrdersCount: openOrdersCount
        }),
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_OpenOrders["default"], {
            config: config
          });
        }
      }, {
        menuItem: t(_FilledOrders["default"].title),
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_FilledOrders["default"], {
            config: config
          });
        }
      }, {
        menuItem: t(_InactiveOrders["default"].title),
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_InactiveOrders["default"], {
            config: config
          });
        }
      }, {
        menuItem: t('Positions ({{openPositionsCount}})', {
          openPositionsCount: openPositionsCount
        }),
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_MarginOpenPositions["default"], {
            config: config
          });
        }
      }, {
        menuItem: t(_PositionHistory["default"].title),
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_PositionHistory["default"], {
            config: config
          });
        }
      }
      /* {
        menuItem: PositionPaymentsContainer.title,
        render: () => <PositionPaymentsContainer config={config} />
      } */];
      return panes;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$location$;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.props.useHeaderWithFilter && /*#__PURE__*/_react["default"].createElement(_HeaderWithFilter["default"], null), /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
        defaultActiveIndex: ((_this$props$location$ = this.props.location.state) === null || _this$props$location$ === void 0 ? void 0 : _this$props$location$.historyTableIndex) || 3,
        panes: this._getPanes(),
        classModifiers: this.props.classModifiers,
        customClass: "order-history"
      }));
    }
  }]);
}(_react.Component);
var mapStateToProps = function mapStateToProps(state, _ref) {
  var config = _ref.config;
  var selectedInstrument = config.filterMode === 'selectedInstrument' ? (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state) : undefined;
  return {
    openOrdersCount: (0, _orderHistorySelectors.openOrdersCountSelector)(state, selectedInstrument),
    openPositionsCount: (0, _selectors.openPositionsCountSelector)(state, config)
  };
};
var _default = exports["default"] = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _reactI18next.withTranslation)('order'), _reactRouterDom.withRouter)(MarginOrderHistoryComponent);